export default __webpack_public_path__ + "static/media/icon-phone-tick.39dc5f6c.svg";